import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DistribuidorDeContenidosService {

  private _contenidoPortada = {
    titulo: "ASOCIACIÓN CIVIL JESÚS AMIGO",
    logo: "../../../assets/img/logo.png",
    fondo: "../../../assets/img/fondo.png"
  };
  public get contenidoPortada() {
    return this._contenidoPortada;
  }

  private _contenidoQuienesSomos = {
    titulo: "¿ QUIÉNES SOMOS ?",
    descripcion: "La nuestra es una Asociación Civil sin fines de lucro que gestiona dos pequeños hogares convivenciales para niños, niñas y adolescentes en situación de vulnerabilidad grave que, por este motivo, fueron separados de sus familias de origen y puestos a resguardo judicialmente para trabajar interdisciplinariamente en la recuperación de su dignidad .",
    datosObjetivos: [
      { imagen: "../../../../assets/img/embrionBorde.png", descripcion: "Defender la vida humana desde la concepcion ." },
      { imagen: "../../../../assets/img/amistadBorde.png", descripcion: "Promover una accion social con sentido cristiano y humano hacia los niños en riesgo y sus familias, defender su dignidad y sus derechos ." },
      { imagen: "../../../../assets/img/campanaBorde.png", descripcion: "Difundir la problematica de los niños y las familias en riesgo ." },
      { imagen: "../../../../assets/img/caridadBorde.png", descripcion: "Capacitar actores sociales que promuevan y protejan los derechos y la dignidad de los niños en riesgo ." },
    ],
    datosAvocados: [
      { imagen: "../../../../assets/img/casaBorde.png", descripcion: "Proteger y promover la dignidad y los derechos de los niños en riesgo a través de pequeños hogares ." },
      { imagen: "../../../../assets/img/voluntarioBorde.png", descripcion: "Generar espacios institucionales para la incorporación de nuevas voluntades en favor de la niñez ." },
      { imagen: "../../../../assets/img/empleadoBorde.png", descripcion: "Promover el trabajo en red con otras instituciones para brindar a los chicos mayores oportunidades ." },
    ],
    subtituloA: "NUESTROS OBJETIVOS SON",
    subtituloB: "NUESTRA TAREA CONSISTE EN",

  };

  public get contenidoQuienesSomos() {
    return this._contenidoQuienesSomos;
  }

  private _contenidoNuestraHistoria = {
    titulo: "NUESTRA HISTORIA",
    descripcion: "Nuestra vida como Institución comienza formalmente el 8 de abril de 1988 en que nos reconoce la Inspección General de Justicia  (Nª 544/88) y consiste en Promover la inclusión social y el ejercicio de los derechos de los niños/as y sus familias en situación de vulnerabilidad psico social en pos de su dignidad y derechos; y brindar, en un marco afectivo, oportunidades para que construyan su proyecto de vida .",
    subtituloA: "CONOCE NUESTRA HISTORIA",
    subtituloB: "NUESTRO HOGAR AHORA"
  };
  public get contenidoNuestraHistoria() {
    return this._contenidoNuestraHistoria;
  }

  private _contenidoNuestroTrabajo = {
    titulo: "NUESTRO TRABAJO",
    descripcion: "Nuestro trabajo comienza desde el ingreso de los niños, niñas y adolescentes en el hogar, cubriendo sus necesidades de la mejor forma posible y enfocados en el proyecto de egreso de los mismos, a fin de que el alojamiento en el hogar sea transitorio .",
    subtituloA: "DENTRO DEL HOGAR",
    subtituloB: "NUESTRO EQUIPO",
    subtituloC: "NUESTROS VOLUNTARIOS",
    equipoDescripcion: "Contamos con un equipo de profesionales que los cuidan y asisten en cada momento: médicos, psicólogos, fonoaudiólogos, musicoterapeutas, trabajadores sociales y un grupo de operadores que interactúan diariamente con los chicos en un ambiente de confianza, reconocimiento, afecto y respeto .",
    datosTrabajo: [
      { imagen: "../../../../assets/img/foto-nuestro-trabajo-1.png", descripcion: "El ingreso de los niños y adolescentes es solicitado a los hogares por el Area de Admision de la Direccion General de Niñez y Adolescencia ante el perido de alojamiento realizado por el Consejo de Derechos de Niños, Niñas y Adolescentes ." },
      { imagen: "../../../../assets/img/foto-nuestro-trabajo-2.png", descripcion: "En este sentido se trabaja con la familia de origen o referentes afectivos, en los casos en los que esto sea posible. Ademas nos vinculamos con otros organismos oficiales con el fin de lograr la reintegracion de niños en la familias ." },
      { imagen: "../../../../assets/img/foto-nuestro-trabajo-3.png", descripcion: "Nuestros niños se integran en el barrio y en la comunidad. Asisten a las escuelas de la zona o aquellas que sean adecuadas a sus necesidades, y desarrollan actividades deportivas, recreativas y de esparcimiento ." }
    ],
    imagenes: [
      { path: '../../../assets/img/foto-nuestro-equipo-1.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-2.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-3.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-4.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-5.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-6.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-7.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-8.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-9.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-10.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-11.jpg' },
      { path: '../../../assets/img/foto-nuestro-equipo-12.jpg' },
    ]
  };
  public get contenidoNuestroTrabajo() {
    return this._contenidoNuestroTrabajo;
  }

  private _contenidoAyuda = {
    titulo: "TU AYUDA ",
    descripcion: "Todo este trabajo está sostenido gracias a los aportes estatales ya que tenemos un convenio con el Gobierno de la Ciudad de Buenos Aires y, por aportes particulares .",
    subtituloA: "NECESITAMOS DE TU AYUDA",
    subtituloB: "COMO PUEDES DONAR",
    datosAyuda: [
      { imagen: "../../../../assets/img/ayuda-transferenciaBorde.png" },
      { imagen: "../../../../assets/img/ayuda-tarjetasBorde.png" },
      { imagen: "../../../../assets/img/ayuda-materialesBorde.png" },
    ],
    textosAyuda: [
      { texto: "Contamos con una gran cantidad de voluntarios que apoyan nuestra labor constantemente con su ayuda concreta en ocasión de los cumpleaños, el inicio de la clases, salidas recreativas y un sin número de ayudas importantes ." },
      { texto: "Nuestra Asociación se asemeja en su forma de trabajo, en el cuidado de los chicos, de su educación, de sus amistades, y de sus vinculaciones sociales, a una familia. Una familia muy grande que cuenta con hasta 14 niños en cada casa ." },
      { texto: "Es por ello que solicitamos el aporte monetario de todos aquellos que quieran y puedan ayudarnos a sostener esta tarea que, para muchos es un trabajo, pero, para nosotros también tiene veta muy importante de misión. Misión de proteger la vida de estos chicos. Vidas breves pero dolorosas, con historias difíciles de resolver y curar ." },
      { texto: "Muchos de los que lean esta página tendrán familia y sabrán lo difícil y costoso que es dar una vida digna a los hijos. Todos los aportes son necesarios y agradecemos por anticipado la generosidad de los que se sientan llamados a colaborar ." }
    ],
  };
  public get contenidoAyuda() {
    return this._contenidoAyuda;
  }

  private _contenidoContacto = {
    titulo: "CONTACTO",
    descripcion: "Si tu sientes la necesidad de colaborar por los niños, niñas y adolescentes, por favor ponte en contacto con nosotros y dejanos saber de que manera desear ayudar. De la misma manera si deseas obtener mas información .",
    subtituloA: "DEJANOS UN MENSAJE",
    subtituloB: "INFORMACIÓN DE CONTACTO",
    texto: "Te invitamos a seguirnos en nuestras redes sociales para que estes al pendiente de nuestras actividades. Al igual si deseas llamarnos o dejarnos un mensaje .",
    datosContacto: [
      { contacto: "Pasaje La Facultad 1628 (CABA)" },
      { contacto: "asociacionjesusamigo@gmail.com" },
      { contacto: "4672-9791" },
      { contacto: "@hogarjesusamigo" },
      { contacto: "Asociación Civil Jesús Amigo" },
      { contacto: "@hogar.jesus.amigo" },
      { contacto: "@HogarJesusAmigo" }
    ]
  };
  public get contenidoContacto() {
    return this._contenidoContacto;
  }


}
